<template>
  <div class="relative w-full h-full">
    <img
      v-if="customImageToShow"
      :src="customImageSrc"
      class="w-full h-full"
      style="object-fit: cover"
      v-bind="$attrs"
    />
    <template v-else>
      <img
        :src="`${storageUrl}/mainImage.jpg`"
        class="w-full h-full"
        style="object-fit: cover"
        v-bind="$attrs"
      />
      <img
        src="@/assets/images/placeholder_overlay.png"
        class="absolute w-3 opacity-80"
      />
      <div class="absolute bg-white opacity-30 h-full w-full"></div>
    </template>
  </div>
</template>

<script>
import { ref, watch, defineComponent } from "vue";

export default defineComponent({
  name: "CustomImageOrDefault",
  inheritAttrs: false,
  props: {
    category_key: {
      type: String,
      default: null,
    },
    view_type: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const storageUrl = process.env.VUE_APP_STORAGE_URL;
    const customImageToShow = ref(false);
    const customImageSrc = ref("");

    function updateCustomImage() {
      if (props.category_key && props.view_type) {
        try {
          // eslint-disable-next-line
          customImageSrc.value = require(`@/assets/images/${props.view_type}/${props.category_key}.png`);
          customImageToShow.value = true;
        } catch (e) {
          customImageToShow.value = false;
          customImageSrc.value = "";
        }
      } else {
        customImageToShow.value = false;
        customImageSrc.value = "";
      }
    }

    // reactively update whenever props change
    watch(() => [props.category_key, props.view_type], updateCustomImage, {
      immediate: true,
    });

    return {
      storageUrl,
      customImageToShow,
      customImageSrc,
    };
  },
});
</script>
